export const WASAPI_SCHEDULE_MESSAGE = 'wasapi:schedule-message';
export const WASAPI_SCHEDULED_MESSAGES_CHANGED =
  'wasapi:scheduled-messages-changed';
